var _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalcFigureVolumeCube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 250 250",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "Artboard1",
    x: 0,
    y: 0,
    width: 250,
    height: 250,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Artboard11"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.05588e-17,0.662376,-0.245851,1.5054e-17,78.4835,49.2514)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.751,106.4L30.751,121.324L15.98,101.425L30.751,81.527L30.751,96.451L152.66,96.451L152.66,81.527L167.431,101.425L152.66,121.324L152.66,106.4L30.751,106.4Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "cube",
    transform: "matrix(1.44952,0,0,1.46817,-46.6778,-78.5882)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.555,195.51L79.94,160.894L140.217,140.217L175.555,175.177L114.555,195.51Z",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "2.74px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0.795007,-66.2836)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.555,195.51L79.94,160.894L140.217,140.217L175.555,175.177L114.555,195.51Z",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "2.74px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M115.35,129.226L114.555,195.51",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "2.74px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-34.6156,-34.6156)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.35,129.226L114.555,195.51",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "2.74px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,25.6615,-55.2928)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.35,129.226L114.555,195.51",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "2.74px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,60.9994,-20.3331)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.35,129.226L114.555,195.51",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "2.74px"
    }
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.561492,-0.191695,0.0794329,0.232665,109.579,197.753)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.471,106.4L32.471,121.324L15.98,101.425L32.471,81.527L32.471,96.451L150.941,96.451L150.941,81.527L167.431,101.425L150.941,121.324L150.941,106.4L32.471,106.4Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.343562,-0.368535,0.179829,-0.167643,97.7238,242.934)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.399,106.4L35.399,121.324L15.98,101.425L35.399,81.527L35.399,96.451L148.012,96.451L148.012,81.527L167.431,101.425L148.012,121.324L148.012,106.4L35.399,106.4Z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.967528,0,0,0.967528,-39.3983,79.2937)"
  }, /*#__PURE__*/React.createElement("text", {
    x: "78.3px",
    y: "36.332px",
    style: {
      fontFamily: "'AndaleMono', 'Andale Mono', monospace",
      fontSize: "18.119px"
    }
  }, "s")), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.967528,0,0,0.967528,91.3753,182.294)"
  }, /*#__PURE__*/React.createElement("text", {
    x: "78.3px",
    y: "36.332px",
    style: {
      fontFamily: "'AndaleMono', 'Andale Mono', monospace",
      fontSize: "18.119px"
    }
  }, "s")), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.967528,0,0,0.967528,-5.06043,168.388)"
  }, /*#__PURE__*/React.createElement("text", {
    x: "78.3px",
    y: "36.332px",
    style: {
      fontFamily: "'AndaleMono', 'Andale Mono', monospace",
      fontSize: "18.119px"
    }
  }, "s")), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.967528,0,0,0.967528,65.9488,131.04)"
  }, /*#__PURE__*/React.createElement("text", {
    x: "78.3px",
    y: "36.332px",
    style: {
      fontFamily: "'AndaleMono', 'Andale Mono', monospace",
      fontSize: "18.119px"
    }
  }, "V"))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalcFigureVolumeCube);
export default __webpack_public_path__ + "static/media/calc-figure-volume-cube.620e60df6f13662928061f9913e972d1.svg";
export { ForwardRef as ReactComponent };